// Services
import apiClient from '@/services/AccountClient'

export default {
  fetchAll (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/banners',
      params,
      options
    )
  },
  fetchById (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/banners/${id}`
    )
  },
  save (id, data) {
    return apiClient.sendRequest(
      ...(id != null ? ['PUT', `api/admin/v1/banners/${id}`] : ['POST', 'api/admin/v1/banners']),
      data
    )
  },
  enable (id, enabled) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/banners/${id}/toggle`,
      { enabled }
    )
  },
  delete (id) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/banners/${id}`
    )
  },
  uploadImage (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/banners/image',
      data,
      { header: { 'Content-Type': 'multipart/form-data' } }
    )
  },
  deleteImage (imageName, bannerId) {
    const queryString = apiClient.serializeParams({ imageName, bannerId }).toString()

    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/banners/image?${queryString}`
    )
  }
}
